import React from 'react';

import { LegacyText } from '@gogame/components';

import { useViewStateByResolveName } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';
import { COMMENT } from 'scenes/MarketingPlanning/MarketingPlanningWizard/constants';

const Comment = () => {
  const commentText = useViewStateByResolveName(COMMENT);

  return <LegacyText ellipsis={true}>{commentText || '-'}</LegacyText>;
};

export default Comment;
